<template>
    <!-- nivel 2 -->
    <intranet-nav-content>
        <template slot="links">
            <div class="intranet-nav-content apk-nav-tabs">
                <intranet-nav-content-link-exact :link="{ name: 'Dashboard', path: { name: 'employee-participants-dashboard' } }"/>
                <intranet-nav-content-link :link="{ name: 'Participantes', path: { name: 'employee-participants-list' } }"/>
                <intranet-nav-content-link :link="{ name: 'Filtros', path: { name: 'employee-participants-filter-documents' } }"/>
                <!-- <intranet-nav-content-link :link="{ name: 'Test', path: { name: 'employee-participants-list-test' } }"/> -->
            </div>
        </template>
    </intranet-nav-content>
</template>

<script>
import IntranetNavContent from '@/layout/NavContent/IntranetNavContent';
import IntranetNavContentLink from '@/layout/NavContent/IntranetNavContentLink';
import IntranetNavContentLinkExact from '@/layout/NavContent/IntranetNavContentLinkExact';

export default {
    name: 'EmployeeParticipants',
    components: { 
        IntranetNavContent,
        IntranetNavContentLink,
        IntranetNavContentLinkExact
    },
};
</script>

<style scoped>
.intranet-nav-content {
    display: flex;
    align-items: center;
    overflow-x:auto;
    white-space:nowrap;
    margin-bottom: 1px;
}
</style>